import type * as Types from '../../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MyGuessesForAssignmentQueryVariables = Types.Exact<{
  assignmentId: Types.Scalars['ID']['input'];
}>;


export type MyGuessesForAssignmentQuery = { __typename?: 'RootQueryType', myGuesses: Array<{ __typename?: 'Guess', id: string, questionId: string, evaluationReleased?: boolean | null, gradeAvailable?: boolean | null, teacherEvaluation?: { __typename?: 'GuessManualEvaluation', overallScore?: number | null, overallFeedback?: string | null, criteriaScores?: Array<{ __typename?: 'GuessCriterionScore', criterionId: string, score?: number | null, feedback?: string | null } | null> | null } | null }> };


export const MyGuessesForAssignmentDocument = gql`
    query MyGuessesForAssignment($assignmentId: ID!) {
  myGuesses(assignmentId: $assignmentId) {
    id
    questionId
    evaluationReleased
    gradeAvailable
    teacherEvaluation {
      overallScore
      overallFeedback
      criteriaScores {
        criterionId
        score
        feedback
      }
    }
  }
}
    `;

/**
 * __useMyGuessesForAssignmentQuery__
 *
 * To run a query within a React component, call `useMyGuessesForAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGuessesForAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGuessesForAssignmentQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useMyGuessesForAssignmentQuery(baseOptions: Apollo.QueryHookOptions<MyGuessesForAssignmentQuery, MyGuessesForAssignmentQueryVariables> & ({ variables: MyGuessesForAssignmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyGuessesForAssignmentQuery, MyGuessesForAssignmentQueryVariables>(MyGuessesForAssignmentDocument, options);
      }
export function useMyGuessesForAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyGuessesForAssignmentQuery, MyGuessesForAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyGuessesForAssignmentQuery, MyGuessesForAssignmentQueryVariables>(MyGuessesForAssignmentDocument, options);
        }
// @ts-ignore
export function useMyGuessesForAssignmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyGuessesForAssignmentQuery, MyGuessesForAssignmentQueryVariables>): Apollo.UseSuspenseQueryResult<MyGuessesForAssignmentQuery, MyGuessesForAssignmentQueryVariables>;
export function useMyGuessesForAssignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyGuessesForAssignmentQuery, MyGuessesForAssignmentQueryVariables>): Apollo.UseSuspenseQueryResult<MyGuessesForAssignmentQuery | undefined, MyGuessesForAssignmentQueryVariables>;
export function useMyGuessesForAssignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyGuessesForAssignmentQuery, MyGuessesForAssignmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyGuessesForAssignmentQuery, MyGuessesForAssignmentQueryVariables>(MyGuessesForAssignmentDocument, options);
        }
export type MyGuessesForAssignmentQueryHookResult = ReturnType<typeof useMyGuessesForAssignmentQuery>;
export type MyGuessesForAssignmentLazyQueryHookResult = ReturnType<typeof useMyGuessesForAssignmentLazyQuery>;
export type MyGuessesForAssignmentSuspenseQueryHookResult = ReturnType<typeof useMyGuessesForAssignmentSuspenseQuery>;
export type MyGuessesForAssignmentQueryResult = Apollo.QueryResult<MyGuessesForAssignmentQuery, MyGuessesForAssignmentQueryVariables>;